var exports = {
  "iM": "shimmer___BNnev",
  "NJ": "shimmerText__N03FuS",
  "qG": "fadeIn__o8Ltfi",
  "TZ": "fadeInAnim__eYFCYD",
};

module.exports = exports;
